import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import InputField from './InputField';
import FormError from './FormError';
import SelectField from './SelectField';
import states from '../helpers/states';
import { formatSaveStatus } from '../helpers/formatters';
import { hasComma, isZip } from '../helpers/validators';

let AddressForm = ({
  handleSubmit,
  initialValues,
  error,
  saveStatus,
  address,
}) => {
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Field component={InputField} name="full_name" label="Full Name*" />
        <Field component={InputField} name="address1" label="Address Line 1" />
        <Field component={InputField} name="address2" label="Address Line 2" />
        <Field component={InputField} name="city" label="City" />
        <Field
          component={SelectField}
          name="state"
          label="State*"
          empty="Choose a state"
          options={states.map((state) => [state.abbreviation, state.name])}
        />
        <Field component={InputField} name="zip_code" label="Zip*" />
        <Field component={InputField} name="phone" label="Phone Number" />
        {error && <FormError error={error} />}
        <br />

        <button className="btn btn-default" disabled={saveStatus === 'PENDING'}>
          Save Address
        </button>

        <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
      </form>
    </div>
  );
};

const validate = (values) => {
  let errors = {};

  if (!values.full_name) {
    errors.full_name = 'Required';
  } else if (values.full_name && hasComma(values.full_name)) {
    errors.full_name = 'Comma sign is not allowed';
  }
  if (!values.address1) {
    errors.address1 = 'Required';
  }
  if (!values.state) {
    errors.state = 'Required';
  }
  if (!values.zip_code) {
    errors.zip_code = 'Required';
  } else if (!isZip(values.zip_code, 'US')) {
    errors.zip_code = 'Please enter a valid zip code';
  }

  return errors;
};

AddressForm = reduxForm({
  form: 'address',
  validate,
})(AddressForm);

export default connect((state) => ({
  enableReinitialize: true,
}))(AddressForm);

export const mapUserToAddress = ({ first_name, last_name }) => ({
  full_name: `${first_name} ${last_name}`,
});
